import {post} from "../functions";

let dataList;
let firstFilter = true;

export function initList() {
    const SECTION_PASSWORD = document.getElementById('passwordSection');
    const PASSWORD_FORM = SECTION_PASSWORD.querySelector('form');
    const PASSWORD_INPUT = SECTION_PASSWORD.querySelector('input');
    const SECTION_DATA = document.getElementById('data');
    const TABLE_ELEMENT_BODY = document.querySelector('#resultTable tbody');
    const TABLE_ELEMENT_TEMPLATE = document.querySelector('template.table-row').innerHTML;
    const SELECT_ELEMENT = document.getElementById('languageSelect');

    let password = '';

    document.addEventListener('DOMContentLoaded', checkPassword);

    async function checkPassword() {
        if (localStorage.getItem('password') === null) {
            SECTION_PASSWORD.style.display = 'flex';
            PASSWORD_INPUT.focus();
        } else {
            password = localStorage.getItem('password');
            const passwordCheck = await load(password);
            if (!passwordCheck) {
                localStorage.removeItem('password');
                PASSWORD_INPUT.value = '';
                PASSWORD_FORM.shake();
                checkPassword();
                return false;
            } else {
                SECTION_PASSWORD.style.display = 'none';
                SECTION_DATA.style.display = 'flex';
                return true;
            }
        }
    }

    document.querySelector('form').addEventListener('submit', (e) => {
        e.preventDefault();
        password = PASSWORD_INPUT.value;

        if (password === '') {
            PASSWORD_FORM.shake();
            PASSWORD_INPUT.focus();
        } else {
            localStorage.setItem('password', password);
            checkPassword();
        }
    })


    async function load(password) {
        const resp = await post('api/list', {password: password});
        console.log(resp);

        if (resp.status === '0' || resp.status === '403') {
            return false;
        } else {
            dataList = resp.message.list;
            return true;
        }
    }

    function render(language) {
        TABLE_ELEMENT_BODY.innerHTML = '';
        Object.entries(dataList).forEach(([id, item]) => {
            if (!item.data.languages.includes(language)) return;
            const rowHtml = TABLE_ELEMENT_TEMPLATE.replace(/\{\{(\w+)\}\}/g, (match, key) => item.data[key] || '');
            const newTemplate = document.createElement('template');
            newTemplate.innerHTML = rowHtml.trim();
            const row = newTemplate.content.firstElementChild;
            TABLE_ELEMENT_BODY.appendChild(row);
        })
    }

    SELECT_ELEMENT.addEventListener('change', () => {
        const selectedLanguage = SELECT_ELEMENT.value;
        if (firstFilter) {
            SELECT_ELEMENT.querySelectorAll('option')[0].remove();
            firstFilter = false;
        }

        render(selectedLanguage);
    })
}